/* !!updating enum may affect mapped types and data */
enum FinancialMetricType {
  CumulativeSavings = 'CUMULATIVE_SAVINGS',
  AverageSavings = 'AVERAGE_SAVINGS_PER_MEMBER',
  LoanFundUtilization = 'LOAN_FUND_UTILIZATION',
}

export default FinancialMetricType;
